import Link from "@pathwright/ui/src/components/link/Link"
import ConnectStores from "lib/core/store/components/ConnectStores"
import * as urls from "lib/core/utils/urls"

const UnusableSubscription = ({ subscription, offering }) => (
  <div style={{ textAlign: "center", padding: "20px" }}>
    <p>
      {`\
You are currently subscribed to the `}
      {subscription.school_plan.name}
      {` which does
not include `}
      {offering.name}
      {`.\
`}
    </p>
    <p>
      {`\
Please `}
      <Link to={urls.modalRoute("/help/")} className="brand-color">{`\
contact support\
`}</Link>
      {` with any questions.\
`}
    </p>
  </div>
)

UnusableSubscription.displayName = "UnusableSubscription"

const mapStateToProps = function (state, ownProps) {
  const { subscription } = state.subscribeStore.state
  const { offering } = state.registerStore.state

  return _.assign(
    {},
    {
      subscription,
      offering
    },
    ownProps
  )
}

const stores = [
  { store: "subscribe", watch: false },
  { store: "register", watch: false }
]

export default ConnectStores(UnusableSubscription, stores, {}, mapStateToProps)
